import { gql } from 'apollo-boost';
export const SHARE_MESSAGE = gql`
    mutation shareMessage($data: ShareMessageInput!) {
        shareMessage(data: $data) {
            sharedEmails
            notFoundEmails
        }
    }
`;
export const REVOKE_MESSAGE_SHARE = gql`
    mutation revokeMessageShare($data: RevokeMessageShareInput!) {
        revokeMessageShare(data: $data)
    }
`;
export const LEAVE_SHARED_MESSAGE = gql`
    mutation leaveSharedMessage($messageId: ID!) {
        leaveSharedMessage(messageId: $messageId)
    }
`;
export const PUBLISH_MESSAGE = gql`
    mutation publishMessage($data: PublishMessageInput!) {
        publishMessage(data: $data) {
            token
            url
            discoverable
            allowCopy
            linkRole
            allowAnonymousContributions
            viewCount
            createdAt
        }
    }
`;
export const UNPUBLISH_MESSAGE = gql`
    mutation unpublishMessage($data: UnpublishMessageInput!) {
        unpublishMessage(data: $data)
    }
`;
